'use client';

import { useEffect, useRef } from 'react';
import { SimpleGrid } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useAddressStore } from '@/src/modules/auth/stores/use-address-store';
import { useGetServiceList } from '@/src/modules/produk-kesehatan/hooks/use-get-service-list';
import { ApplicationError } from '../../errors';
import ConsultCardSkeleton from '../produk-kesehatan/consult-list/ConsultCardSkeleton';
import { ServiceCard } from '../produk-kesehatan/consult-list/ServiceCard';

export default function LayananGrid() {
  const { execute, data, isLoading, error } = useGetServiceList();
  const PAGE_SIZE = 5;
  const services = data?.data ?? [];
  const hasFetched = useRef(false);
  const coordLat = useAddressStore((s) => s.currentLat);
  const coordLong = useAddressStore((s) => s.currentLong);

  useEffect(() => {
    if (hasFetched.current) {
      return;
    }

    if (coordLat && coordLong) {
      hasFetched.current = true;
    }

    execute({
      offset: 1,
      size: PAGE_SIZE,
      lat: coordLat,
      long: coordLong,
      order_by: 'nearest',
    });
  }, [coordLat, coordLong]);

  useEffect(() => {
    if (!error) {
      return;
    }

    if (error instanceof ApplicationError) {
      notifications.show({
        title: error.name,
        message: error.message,
        color: 'red',
      });
      return;
    }

    notifications.show({
      title: 'Error',
      message: 'Terjadi kesalahan saat memuat data rekomendasi layanan.',
      color: 'red',
    });
  }, [error]);
  const msInHour = Date.now() % (1000 * 60 * 60);
  return (
    <SimpleGrid
      cols={{ base: 2, md: 3, xl: 5 }}
      spacing={{ base: 'sm', lg: 'lg' }}
      verticalSpacing={{ base: 'sm', lg: 'lg' }}
      mb="xl"
    >
      {isLoading
        ? Array.from({ length: PAGE_SIZE }).map((_, i) => (
            <ConsultCardSkeleton key={i} />
          ))
        : services.map((service) => (
            <ServiceCard
              key={`service-${service.bpis_id}-${service.individual_id}-${msInHour}`}
              service={service}
            />
          ))}
    </SimpleGrid>
  );
}
